'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useEffect, useRef } from 'react';
import useNetworkStatus from '../useNetworkStatus';
import { useMessageContext } from '@/components/Messages';
function useOfflineMessage() {
  const $ = _c(6);
  const t = useTranslations();
  const networkStatus = useNetworkStatus();
  const {
    addMessage,
    removeMessage
  } = useMessageContext();
  const messageRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== addMessage || $[1] !== networkStatus || $[2] !== removeMessage || $[3] !== t) {
    t0 = () => {
      if (networkStatus === "offline") {
        messageRef.current = addMessage({
          type: "warning",
          message: t("nextjs.errors.messages.offline")
        });
        return;
      }
      const message = messageRef.current;
      if (!message) {
        return;
      }
      removeMessage(message);
      return () => {
        removeMessage(message);
      };
    };
    t1 = [addMessage, networkStatus, removeMessage, t];
    $[0] = addMessage;
    $[1] = networkStatus;
    $[2] = removeMessage;
    $[3] = t;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
}
export default useOfflineMessage;